import { DatePipe } from '@angular/common';
import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    Input,
    AfterViewInit,
    OnDestroy,
    ElementRef,
    effect} from '@angular/core';
import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
    ApiEndPointConstants,
    HelperService,
    IdentifierService,
    ToasterClass,
} from 'merlin-core';
import {
    CustomerType,
    PopupConfig,
    PopupService,
    PopupType,
    SpinnerService,
    UserProfileObject,
    UserService,
} from 'merlin-library';
import { ToastrService } from 'ngx-toastr';
import { Mode } from '../../clinic-admin/clinic-users/services/clinic-users-data';
import { FrontEndErrMsgs } from '../enums/patient-device-data.enum';
import { CustomDateAdapter } from '../manual-patient-enroll/followup-schedule/customDateAdapter';
import { DateTimeService } from '../manual-patient-enroll/followup-schedule/date-time.service';
import { PICK_FORMATS } from '../manual-patient-enroll/patient-device-data/patient-device-data.component';
import { PatientProfilePrintDialogComponent } from '../patient-profile-print-dialog/patient-profile-print-dialog.component';
import {
    EnrollPatientTransmitter,
    VolumeCode,
} from '../services/enroll-patient-transmitter.model';
import { EnrollPatientTransmitterService } from '../services/enroll-patient-transmitter.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalizationService, ReturnType } from 'src/core/utilitites/localization.service';
import { GlobalInputSecurityService } from 'src/core/utilitites/global-input-security.service';
import { EnrollPatientDeviceDataService } from '../services/enroll-patient-device-data.service';
import { ActionError } from '../../my-account/services/my-account.model';
import { TRANSMITTER_FIELD } from './transmitter.model';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import { PatientListService } from '../services/patient-list.service';
import { ReleasePatientDialogComponent } from '../release-patient-dialog/release-patient-dialog.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { FunctionMode } from '../manual-patient-enroll/enums/enroll-patient.enum';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { CustDateAdapter } from '../followup-schedule/Calender';
import { MyFormat } from '../manual-patient-enroll/followup-schedule/date-format/my-date-format';
import moment, { isMoment } from 'moment';
import { IcmaiDevicesDialogComponent } from '../../shared/icmai-devices-dialog/icmai-devices-dialog.component';

@Component({
    selector: 'app-enroll-patient-transmitter',
    templateUrl: './enroll-patient-transmitter.component.html',
    styleUrls: ['./enroll-patient-transmitter.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        {
            provide: DateAdapter,
            useClass: CustDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useClass: MyFormat },
    ],
    standalone: false
})
export class EnrollPatientTransmitterComponent
    implements OnInit, AfterViewInit, OnDestroy {
    enrollPatientTransmitterFormGroup: UntypedFormGroup;
    bluetoothCapable: boolean;
    icmDeviceType: boolean;
    lpDeviceType: boolean =false;
    mistFlagSelection: boolean;
    nodcFlagSelection: boolean;
    directAlertSelection: boolean;
    isChecked: boolean = false;
    followUpCapable: boolean;
    transmitterSerialRqdFlag: boolean;
    mode = Mode.View;
    deviceRfStatusFlag: boolean;
    enrollPatientTransmitter: EnrollPatientTransmitter;
    @Output() goForward = new EventEmitter();
    @Output() navBackward = new EventEmitter();
    @Input() patientid;
    @Input() patientMgmtId;
     tz: string;
    @Input() isBack;
    public errorMsgs = [];
    public dataMsgs = [];
    public isError = false;
    public errorHeading;
    lockOutTransCheckboxFlag: boolean;
    lockOutDeviceCheckboxFlag: boolean;
    enhancedDiagDataCollectionFlag: boolean;
    rfDailyCheckEnabledFlag: boolean;
    userProfileData: any = {};
    date: Date;
    netTransmitterInfo: any;
    identifyKeyEpisodeFlg: any = null;
    effectiveKeyEpisodeFlg;
    showIdentifyKeyEpisodesSetting: boolean;
    isCheckedValue: boolean;
    showKeyEpisodeIcon: boolean;

    @Input('functionMode') functionMode: string;
    displayMode: string = 'view';
    viewData: any = {};

    needConfirmationOnClose = true;
    clickSaveAndClose: boolean = false;
    hasPatientDataEntryAccess: boolean;
    isSP2CanEnroll: boolean;
    patRes;
    deviceModelNumber;
    isICM4500: boolean;
    showMistFlgOverride: boolean;
    showMistThresholdOverride: boolean;
    showNodcFlgOverride: boolean;
    showNodcThresholdOverride: boolean;
    baMistThresholdSaved?: number;
    hideBatteryAdvisory?:boolean
    batteryAdvisory?: boolean;
    bluetoothMistThreshold?: number;
    bluetoothNodcThreshold?: number;
    enhancedDiagDataCollectionNewflag?: boolean;
    devMedScheduleDaily?: boolean;
    complianceReport?: boolean;
    devMedFlag: boolean = false;
    defaultMistThresholdForScheduleDaily?: number;
    isPatientRelease: boolean = false;
    releasePatientMsg: string;
    viewEnhancedDiagDataFlag: boolean;
    deviceInductive?: boolean;
    showOverridebutton = false;
    toasterRef: any;
    locale: any;
    activatorClinicFlg: boolean = false;
    ngqDeviceType: boolean;
    unityDeviceType: boolean;
    oldTransmitterSerialNum: string='';
    oldTransmitterModelNum: string='';

    transmitterModelString: string = '';
    profileTransmitterModelNum: string = '';
    profileSerial: string = '';
    snoozeDateString: string = '';
    public htmlLabels: string[] = [
      'label.gb.identify_KE_info'
    ];
    public translatedHtmlLabels: Record<string, string>;
    public stringLabels = [
        "label.gb.transmitter",
        "label.gb.edit",
        "label.gb.button_cancel",
        "label.gb.save",
        "label.gb.print_profile",
        "label.gb.release_patient",
        "label.gb.reactivate_pat",
        "label.gb.more_actions",
        "msg.gb.transmitter_details_prompt",
        "msg.gb.transmitter_setup_prompt",
        "label.gb.trans_serial_no",
        "label.gb.tranmsitter_model",
        "label.gb.pt_app_sw_ver",
        "label.gb.reg_date",
        "msg.gb.transmitter_setup_note",
        "msg.gb.transmitter_lastconn_prompt_icm",
        "msg.gb.transmitter_lp_lastconn_prompt",
        "msg.gb.transmitter_lastconn_prompt",
        "label.gb.tranmsitter_model",
        "label.gb.trans_sw_version",
        "label.gb.connection_type",
        "label.gb.last_comm_date",
        "label.gb.last_device_check",
        "label.gb.settings",
        "label.gb.remove_overrides",
        "label.gb.perform_daily_dev_chk",
        "label.gb.identify_KE",
        "label.gb.show_ICM_devices",
        "label.gb.lockout_unscheduled_transmissions",
        "label.gb.lockout_lp_tooltip",
        "label.gb.lockout_device_checks",
        "label.gb.coll_enhncd_dgnstic_data",
        "label.gb.trans_vol",
        "label.gb.compliance_hdr",
        "msg.pa500.prompt",
        "msg.pa501.prompt",
        "msg.pa502.prompt",
        "label.gb.enable_tx_monitoring",
        "label.gb.tx_monitoring_setting",
        "label.gb.days",
        "label.gb.snooze_threshold_until",
        "label.gb.enable_dc_monitoring",
        "label.gb.dc_monitoring_setting",
        "label.gb.tx_monitoring_note2_ICM",
        "label.gb.compliance_note",
        "label.gb.required_field",
        "label.gb.override_instr_text",
        "label.gb.back",
        "label.gb.button_cancel",
        "label.gb.saveandclose",
        "label.gb.continue",
        "label.gb.n_a",
        'label.gb.rec_shpmnt_info',
        'label.gb.trans_serial_no',
        'label.gb.tranmsitter_model',
        'label.gb.ordered_date',
        'label.gb.shipped_date'
    ]

    public labels: Record<string, string>;
    datePlaceholder: string;

    constructor(
        private formBuilder: UntypedFormBuilder,
        public dataService: EnrollPatientTransmitterService,
        private spinnerService: SpinnerService,
        private helperService: HelperService,
        private router: Router,
        private toastrService: ToastrService,
        private userService: UserService,
        private dateFormatService: DateTimeService,
        public datepipe: DatePipe,
        public dialog: MatDialog,
        private translateService: TranslateService,
        private localizationService: LocalizationService,
        private enrollService: EnrollPatientDeviceDataService,
        private route: ActivatedRoute,
        public identifierService: IdentifierService,
        private patientListService: PatientListService,
        private popupService: PopupService,
        private dateAdapter: DateAdapter<any>,
        private elementRef: ElementRef,
        private globalInputSecurity: GlobalInputSecurityService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
        this.generateTransmitterForm();
    }

    ngOnInit() {
        this.translatedHtmlLabels = this.localizationService.loadLocalizedHtmls(this.htmlLabels);
        this.translateStrings();
        this.toastrService.clear();
        this.getUserProfileData();
        if (this.functionMode == 'enroll') {
            this.mode = Mode.Edit;
        }
        this.enrollService.updateDeviceFormDirty(false);
        this.enrollPatientTransmitterFormGroup.valueChanges.subscribe(() => {
            this.enrollService.updateDeviceFormDirty(
                this.enrollPatientTransmitterFormGroup.dirty
            );
        });
        this.getPatientData();
        this.setDatePickerLocale();
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    appendStringsToLabelList(listToAppend: string[]){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, listToAppend);
    }

    pareViewDataStrings(viewData){
        this.transmitterModelString = this.localizationService
                                        .generateLocalizedStr(this.showTranmissterModel(viewData));
        this.profileTransmitterModelNum = this.localizationService
                                            .generateLocalizedStr(this.getProfileTransmitterModelNum(viewData));
        this.profileSerial = this.localizationService
                                            .generateLocalizedStr(this.getProfileSerial(viewData.transmitterSerialNum));
        if (viewData.appSWVersion) {
            viewData.appSWVersion = this.translateService.instant(viewData.appSWVersion);
        }
        if (viewData.registrationDate) {
            viewData.registrationDate = this.translateService.instant(viewData.registrationDate);
        }
    }

    dateClass = (cellDate, view) => {
        if (![null, ''].includes(cellDate)) {
            const date = cellDate.date();
            const today = this.helperService.getCurrentDateByTimeZone(this.tz);
            let cellClass = today.getDate() === date &&
                today.getMonth() == new Date(cellDate).getMonth() &&
                today.getFullYear() == new Date(cellDate).getFullYear()
                ? 'current__date' : 'no_current_date';
            return (new Date(cellDate).getDay() == 6 || new Date(cellDate).getDay() == 0) ? cellClass + ' weekend-day' : cellClass
        }
        return '';
    };

    setDatePickerLocale() {
        this.localizationService.getCurrentLanguage().subscribe(language => {
            this.locale = language?.split('_')[1];
            this.dateAdapter.setLocale(this.locale);
        });
    }

    ngAfterViewInit(): void { }

    ngOnDestroy(): void {
        this.globalInputSecurity.dismissXssToasts();
    }
    generateTransmitterForm() {
        this.enrollPatientTransmitterFormGroup = this.formBuilder.group({
            patientId: [''],
            transmitterSerialNum: [''],
            transmitterModelNum: [''],
            profileTransmitterSerialNum: [''],
            profileTransmitterModelNum: [''],
            transmitterSoftwareVersion: [''],
            lastConnectionType: [''],
            lastCommunicationDate: [''],
            rfDailyCheckEnabled: [''],
            identifyKeyEpisodeFlg: [],
            effectiveKeyEpisodeFlg: [],
            lastDeviceCheckDate: [''],
            lockoutTransEnabled: [''],
            lockOutDeviceCheckEnabled: [''],
            enhancedDiagDataCollection: [''],
            shippedSerialNum: [''],
            shippedDate: [''],
            shippedModelNum: [''],
            orderedDate: [''],
            mistFlg: [''],
            nodcFlg: [''],
            snoozeUntilDate: [''],
            complianceNote: [''],
            registrationDate: [''],
            patAppSwVersion: [''],
            mistThreshold: new UntypedFormControl(''),
            nodcThreshold: new UntypedFormControl(''),
            transmitterVolumeCd: [''],
        });
    }
    transmitterDetails: any;
    customerJson: any;
    viewTransmitterData() {
        this.directAlertSelection = false;
        this.mistFlagSelection = false;
        this.dataService.getTransmitterData(this.patientid).subscribe(
            (res: EnrollPatientTransmitter) => {
                let transmitterSerialNum = ![null, ''].includes(
                    res.transmitterSerialNum
                )
                    ? String(res.transmitterSerialNum)
                    : '';
                res = {
                    ...res,
                    transmitterSerialNum:
                        transmitterSerialNum == '0' ? '' : transmitterSerialNum,
                };
                this.customerJson = {
                    ...res?.customerScheduleMethodDTO,
                    clinicMistFlg: res?.clinicMistFlg,
                    clinicNodcFlg: res?.clinicNodcFlg,
                    clinicMistThreshold: res?.clinicMistThreshold,
                    clinicNodcThreshold: res?.clinicNodcThreshold,
                };
                this.transmitterDetails = res;
                this.netTransmitterInfo = res.netTransmitterInfo;
                this.enrollPatientTransmitterFormGroup
                    ?.get('identifyKeyEpisodeFlg')
                    .setValue(res.identifyKeyEpisodeFlg);
                this.enrollPatientTransmitterFormGroup
                    ?.get('effectiveKeyEpisodeFlg')
                    .setValue(res.identifyKeyEpisodeFlg);
                this.showIdentifyKeyEpisodesSetting =
                    res?.showIdentifyKeyEpisodesSetting;
                this.isICM4500 = res?.showIdentifyKeyEpisodesSetting;
                this.viewData = JSON.parse(JSON.stringify(res));
                this.pareViewDataStrings(this.viewData);
                this.bluetoothCapable = res.bluetoothCapable;
                this.deviceRfStatusFlag = res.deviceRfStatusFlag;
                this.baMistThresholdSaved = res.baMistThresholdSaved;
                this.bluetoothCapable = res.bluetoothCapable;
                this.batteryAdvisory = res.batteryAdvisory;
                this.bluetoothMistThreshold = res.bluetoothMistThreshold;
                this.bluetoothNodcThreshold = res.bluetoothNodcThreshold;
                this.complianceReport = res.complianceReport
                this.enhancedDiagDataCollectionNewflag =
                    res.enhancedDiagDataCollectionNewflag;
                this.devMedScheduleDaily = res.devMedScheduleDaily;
                this.deviceInductive = res.deviceInductive;
                this.nodcFlagSelection = res.nodcFlg;
                this.hideBatteryAdvisory= res.hideBatteryAdvisory;
                this.icmDeviceType = res?.deviceType === 'ICM';
                this.ngqDeviceType = res?.deviceType === 'NGQ';
                this.lpDeviceType = res?.deviceType === 'LP';
                this.unityDeviceType = ['ICD', 'PACE'].includes(res?.deviceType);
                this.oldTransmitterModelNum = res?.transmitterModelNum;
                this.oldTransmitterSerialNum = res?.transmitterSerialNum;

                if (res.rfDailyCheckEnabled) {
                    this.directAlertSelection = true;
                }
                // this.enrollPatientTransmitterFormGroup.get('mistFlg').disable();
                if (res.mistFlg) {
                    this.mistFlagSelection = true;
                }

                let modifyResponse = {
                    ...res,
                    mistThreshold:
                        res?.clinicMistThreshold != 0
                            ? res.mistThreshold == 0
                                ? res?.clinicMistThreshold
                                : res?.mistThreshold
                            : res?.mistThreshold == 0
                                ? res?.defaultMistThreshold
                                : res?.mistThreshold,
                    nodcThreshold:
                        res?.clinicNodcThreshold != 0
                            ? res?.nodcThreshold == 0
                                ? res?.clinicNodcThreshold
                                : res.nodcThreshold
                            : res?.nodcThreshold == 0
                                ? res?.defaultNodcThreshold
                                : res.nodcThreshold,
                    mistThresholds: res?.mistThresholds.map((item: any) => {
                        return {
                            ...item,
                            value: +item.value,
                            label:
                                item.value +
                                ' ' +
                                this.translateService.instant('label.gb.days'),
                        };
                    }),
                    nodcThresholds: res?.nodcThresholds.map((item: any) => {
                        return {
                            ...item,
                            value: +item.value,
                            label: item.label,
                        };
                    }),

                    transmitterModelNum:
                        res?.transmitterModelNum != null
                            ? (res?.transmitterModelNum == 'label.gb.n_a'
                                ? this.translate(res?.transmitterModelNum)
                                : res?.transmitterModelNum)
                            : this.labels['label.gb.n_a'],
                    patAppSwVersion: res?.appSWVersion
                        ? this.translateService.instant(res?.appSWVersion)
                        : null,
                    registrationDate: res?.registrationDate
                        ? this.translateService.instant(res?.registrationDate)
                        : null,
                    lastCommunicationDate:
                        res?.lastCommunicationDate != null
                            ? res?.lastCommunicationDate
                            : this.labels['label.gb.n_a'],

                    lastDeviceCheckDate:
                        res?.lastDeviceCheckDate != null
                            ? res?.lastDeviceCheckDate
                            : this.labels['label.gb.n_a'],

                    shippedSerialNum:
                        res?.shippedSerialNum != null
                            ? res?.shippedSerialNum
                            : this.labels['label.gb.n_a'],

                    shippedModelNum:
                        res?.shippedModelNum != null
                            ? res?.shippedModelNum
                            : this.labels['label.gb.n_a'],

                    orderedDate:
                        res?.orderedDate != null
                            ? res?.orderedDate
                            : this.labels['label.gb.n_a'],

                    shippedDate:
                        res?.shippedDate != null
                            ? res?.shippedDate
                            : this.labels['label.gb.n_a'],

                    profileTransmitterSerialNum:
                        res?.profileTransmitterSerialNum != null
                            ? res?.profileTransmitterSerialNum
                            : this.labels['label.gb.n_a'],

                    profileTransmitterModelNum:
                        res?.profileTransmitterModelNum != null
                            ? res?.profileTransmitterModelNum
                            : this.labels['label.gb.n_a'],

                    transmitterSoftwareVersion:
                        res?.transmitterSoftwareVersion != null
                            ? res?.transmitterSoftwareVersion
                            : this.labels['label.gb.n_a'],
                };
                this.enrollPatientTransmitter = modifyResponse;
                this.parseNodcThresholdsLabels(this.enrollPatientTransmitter.nodcThresholds);
                this.parseVolumeCdLabels(this.enrollPatientTransmitter.dropdowns.volumeCd);

                this.enrollPatientTransmitterFormGroup.patchValue(
                    modifyResponse
                );

                /*
                * applyDefaultCheckboxStates must run AFTER patchValue so that
                * device-capability defaults are not overwritten by stale API values from the previous device selection.
                */
                this.applyDefaultCheckboxStates();
                this.showMistFlgOverride =
                    this.enrollPatientTransmitter.mistFlg !=
                    modifyResponse.clinicMistFlg;
                this.showNodcFlgOverride =
                    this.enrollPatientTransmitter.nodcFlg !=
                    modifyResponse.clinicNodcFlg;

                this.showMistThresholdOverride = this.enrollPatientTransmitter.mistFlg ?
                    (this.enrollPatientTransmitter.mistThreshold !=
                    modifyResponse.clinicMistThreshold) : false;
                this.showNodcThresholdOverride = this.enrollPatientTransmitter.nodcFlg ?
                    (this.enrollPatientTransmitter.nodcThreshold !=
                    modifyResponse.clinicNodcThreshold) : false;
                this.removeOverrideChecks();
                this.bindFieldsData(modifyResponse);
                this.disableTransmitterProperties();
                let snoozeUntilDateRaw =
                    this.enrollPatientTransmitterFormGroup.get(
                        'snoozeUntilDate'
                    ).value;
                if (snoozeUntilDateRaw) {
                    this.enrollPatientTransmitterFormGroup
                        .get('snoozeUntilDate')
                        .setValue(
                             moment(snoozeUntilDateRaw, this.dateFormat.toUpperCase(),true).toDate()
                        );
                }
                if ((!this.hideBatteryAdvisory) && (this.devMedScheduleDaily && this.batteryAdvisory)){
                    this.devMedFlag = true;
                    this.defaultMistThresholdForScheduleDaily = 1;
                    if (res.mistThreshold == 1 ) {
                        this.showMistFlgOverride = false;
                        this.showMistThresholdOverride = false;
                    }
                }
                this.updateSettingDisabledStates();
            },
            (error) => {
                this.helperService.showErrorToastr(error);
                this.spinnerService.visibility = false;
            }
        );
    }

    parseNodcThresholdsLabels(elements){
        let stringsToAppend = [];
        // Validate 'elements' is iterable (not null or undefined) before iterating
        if(elements && Array.isArray(elements)){
            for(let element of elements){
                stringsToAppend.push(element.label)
            }
        }
        this.appendStringsToLabelList(stringsToAppend);
    }

    parseVolumeCdLabels(elements){
        let stringsToAppend = [];
        // Validate 'elements' is iterable (not null or undefined) before iterating.
        if(elements && Array.isArray(elements)){
            for(let element of elements){
                stringsToAppend.push('data.Code.Transmitter_Volume_Cd.Code_Desc.' + element.code)
            }
        }
        this.appendStringsToLabelList(stringsToAppend);

    }

    displayLockoutUnschedTooltip(){
        return this.lpDeviceType;
    }

    getText(): string {
        const deviceType = this.enrollPatientTransmitter?.deviceType;
        if (deviceType !== 'ICM') {
            return this.translateService.instant(
                this.devMedScheduleDaily
                    ? 'label.gb.tx_monitoring_note5_CRM'
                    : 'label.gb.tx_monitoring_note1_CRM'
            );
        }

        return this.translateService.instant('label.gb.tx_monitoring_note1_ICM');
    }


    getTransmissionHeadingDisplay() {

        if (
            this.enrollPatientTransmitter?.deviceType == 'ICD' ||
            this.enrollPatientTransmitter?.deviceType == 'ICDPM' ||
            this.enrollPatientTransmitter?.deviceType == 'PACE' ||
            this.enrollPatientTransmitter?.deviceType == 'LP'
        ) {
            return this.translateService.instant(
                'label.gb.transmitter_setup_pref'
            );
        }
        return this.translateService.instant('label.gb.trans_dtls');
    }

    // ---------------- Checkbox State Helpers (moved from verbose template logic) ----------------
    isViewMode(): boolean { return this.mode === Mode.View; }


    /** rfDailyCheckEnabled checkbox: whether it should be disabled */
    isRfDailyCheckDisabled(): boolean {
        if (!this.enrollPatientTransmitter) { return true; }
        const formCtrl = this.enrollPatientTransmitterFormGroup.get('rfDailyCheckEnabled');
        if (!formCtrl) { return true; }
        if (this.isViewMode()) { return true; } // always disabled in view mode
        const device = this.enrollPatientTransmitter;
        // Logic for bluetooth-capable vs non-bluetooth devices
        const isBluetoothCapableDisabled = this.bluetoothCapable && !device?.followUpCapable;
        const isNonBluetoothDisabled = !this.bluetoothCapable && ((device?.followUpCapable && !device.deviceRfStatusFlag) ||
            (!device?.followUpCapable && !((device?.rfDailyCheckEnabled || device?.deviceSwitchOverrideFlag) && !(device?.rfDailyCheckEnabled && device?.deviceSwitchOverrideFlag))));
        return isBluetoothCapableDisabled || isNonBluetoothDisabled;
    }
    /** lockoutTransEnabled checkbox: whether it should be disabled */
    isLockoutTransDisabled(): boolean {
        const data = this.enrollPatientTransmitter;
        if (!data) { return true; }
        if (this.mode === Mode.View) return true;
        if (!this.bluetoothCapable && data.followUpCapable && data.deviceFamily === 1) return true;
        if (!this.bluetoothCapable && !data.followUpCapable && data.deviceSwitchOverrideFlag) return true;
        return false;
    }

    isLockoutDeviceDisabled(): boolean {
        const data = this.enrollPatientTransmitter;
        if (!data) { return true; }
        if (!this.bluetoothCapable && data.followUpCapable && data.deviceFamily === 1) { return true; }
        const overrideLock = !this.bluetoothCapable && !data.followUpCapable && data.deviceSwitchOverrideFlag === true;
        return this.isViewMode() || overrideLock;
    }

    isEnhancedDiagDisabled(): boolean {
        const data = this.enrollPatientTransmitter;
        if (!data) { return true; }
        const followUpCapableDisabled = data.followUpCapable && !(data.advisoryIndicationCode === '' || data.advisoryIndicationCode === 'LASER' || data.advisoryIndicationCode === 'LVHDR' || data.advisoryIndicationCode === 'PMIEM' || data.isEnableDataCollection || data.advisoryIndicationCode !== 'BATTERYADV');
        const nonFollowUpCapableDisabled = !data.followUpCapable && data.deviceSwitchOverrideFlag === true;
        return this.isViewMode() || followUpCapableDisabled || nonFollowUpCapableDisabled;
    }

    isKeyEpisodeDisabled(): boolean { return this.isViewMode(); }

    /** Central disable logic */
    private updateSettingDisabledStates(): void {
        const fg = this.enrollPatientTransmitterFormGroup;
        if (!fg) return;
        const apply = (c: string, disabled: boolean) => {
            const ctrl = fg.get(c);
            if (!ctrl) return;
            disabled ? ctrl.disable({ emitEvent: false }) : ctrl.enable({ emitEvent: false });
        };

        apply('rfDailyCheckEnabled', this.isRfDailyCheckDisabled());
        apply('lockoutTransEnabled', this.isLockoutTransDisabled());
        apply('lockOutDeviceCheckEnabled', this.isLockoutDeviceDisabled());
        apply('enhancedDiagDataCollection', this.isEnhancedDiagDisabled());
        apply('effectiveKeyEpisodeFlg', this.isKeyEpisodeDisabled());
        apply('mistFlg', this.transmitterCommunicationDisable());
        apply('nodcFlg', this.directAlertsChecboxDisable());

        if (fg.get('mistThreshold')) {
            apply('mistThreshold', !this.showMistThresholdSelector());
        }
        if (fg.get('nodcThreshold')) {
            //apply('nodcThreshold', !this.showNodcThresholdSelector());
        }
        if (!this.deviceRfStatusFlag && !this.bluetoothCapable) {
            this.enrollPatientTransmitterFormGroup
                .get('rfDailyCheckEnabled')
                ?.disable();
        }

        if (this.enhancedDiagDataCollectionNewflag == true) {
            this.enrollPatientTransmitterFormGroup
                .get('enhancedDiagDataCollection')
                ?.disable();

        } else if (this.displayMode == 'view') {
            this.viewEnhancedDiagDataFlag = true;
        } else {
            this.enrollPatientTransmitterFormGroup
                .get('enhancedDiagDataCollection')
                ?.enable();
        }
    }
    // Diamonds (override indicator) helpers
    showOverrideDiamond(formKey: string, customerKey: string): boolean {
        if (!this.customerJson) { return false; }
        const ctrl = this.enrollPatientTransmitterFormGroup.get(formKey);
        if (!ctrl) { return false; }
        return ctrl.value !== this.customerJson[customerKey];
    }
    // -------------------------------------------------------------------------------------------

    showdeviceInductiveHeaderlabel(){
        if((
        this.enrollPatientTransmitter?.deviceType == 'ICD' ||
        this.enrollPatientTransmitter?.deviceType == 'PACE') && this.deviceInductive){
            return this.translateService.instant(
                'msg.pa502.prompt'
            );

        }
    }
    getLastConnectionHeadingDisplay() {
        return this.translateService.instant('label.gb.last_communication');
    }
    removeOverrideChecks() {
        if (
            this.enrollPatientTransmitterFormGroup.value['lockoutTransEnabled']
        ) {
            this.lockOutTransCheckboxFlag = true;
        }
        if (
            this.enrollPatientTransmitterFormGroup.value[
            'lockOutDeviceCheckEnabled'
            ]
        ) {
            this.lockOutDeviceCheckboxFlag = true;
        }
        if (
            this.enrollPatientTransmitterFormGroup.value[
            'enhancedDiagDataCollection'
            ]
        ) {
            this.enhancedDiagDataCollectionFlag = true;
        }
        if (
            this.enrollPatientTransmitterFormGroup.value['rfDailyCheckEnabled']
        ) {
            this.rfDailyCheckEnabledFlag = true;
        }

        // if (
        //     this.enrollPatientTransmitterFormGroup.value['identifyKeyEpisodeFlg']
        // ) {
        //     this.identifyKeyEpisodeFlg = true;
        // }
      //  this.enrollPatientTransmitterFormGroup.markAsDirty();
    }

    isOverideOnEnroll(fieldName: string, jsonKey: string) {
        // if (this.functionMode == 'enroll') {
        //     return false;
        // }
        if (!this.customerJson) { return false; }
        if(fieldName == 'enhancedDiagDataCollection' && this.enhancedDiagDataCollectionNewflag == true){
            return false;
        }
        return (
            this.enrollPatientTransmitterFormGroup.get(fieldName)?.value !=
            this.customerJson[jsonKey]
        );
    }

    isOverrideSymbol(formKey: string, jsonKey) {
        // if (this.functionMode == 'enroll') {
        //     return false;
        // }
    }

    onChangeValue(event: MatCheckbox) {
        if (!event.checked) {
            this.isCheckedValue = true;
        } else {
            this.isCheckedValue = false;
        }
    }
    onCheckboxChange(event) {
        if (event.checked) {
            this.directAlertSelection = true;
            if (this.enrollPatientTransmitterFormGroup.get('mistFlg')?.value) {
                this.enrollPatientTransmitterFormGroup.get('nodcFlg').enable();
            }


        } else {
            this.enrollPatientTransmitterFormGroup.get('nodcFlg').disable();
            this.enrollPatientTransmitterFormGroup
                .get('nodcFlg')
                .patchValue(false);
            this.directAlertSelection = false;
            this.nodcFlagSelection = false;
        }
        this.updateSettingDisabledStates();
    }
    onCheckboxChangeKeyEpi(event) {
        if (event.checked) {
           this.showKeyEpisodeIcon = true;
           this.identifyKeyEpisodeFlg = true;
           this.effectiveKeyEpisodeFlg = true;

        } else {
         this.showKeyEpisodeIcon = false;
        this.identifyKeyEpisodeFlg = false;
        this.effectiveKeyEpisodeFlg = false;

        }
    }
    onMistFlagSelection(event) {
        if (event.checked) {
            this.mistFlagSelection = true;
            if (this.enrollPatientTransmitterFormGroup.get('rfDailyCheckEnabled')?.value) {
                this.enrollPatientTransmitterFormGroup.get('nodcFlg').enable();
            }

        } else {
            this.enrollPatientTransmitterFormGroup
                .get('nodcFlg')
                .patchValue(false);
            this.enrollPatientTransmitterFormGroup.get('nodcFlg').disable();
            //  this.enrollPatientTransmitterFormGroup.get('mistFlg').patchValue(false);
            this.mistFlagSelection = false;
            this.nodcFlagSelection = false;
        }
        this.updateSettingDisabledStates();
    }

    onNodcFlagSelection(event) {
        if (event.checked) {
            this.nodcFlagSelection = true;
        } else {
            this.nodcFlagSelection = false;
        }
        this.updateSettingDisabledStates();
    }

    disableTransmitterProperties() {
        const tz = this.dateFormat.toUpperCase();
        dayjs.extend(customParseFormat);
        if (this.enrollPatientTransmitterFormGroup.get('orderedDate').value) {
            const orderDate = dayjs(
                this.enrollPatientTransmitterFormGroup.get('orderedDate').value
            ).format(tz) as any;
            this.enrollPatientTransmitterFormGroup
                .get('orderedDate')
                .patchValue(
                    orderDate == 'Invalid Date'
                        ? this.labels['label.gb.n_a']
                        : orderDate
                );
        }
        this.enrollPatientTransmitterFormGroup.controls[
            'patAppSwVersion'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'registrationDate'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'profileTransmitterSerialNum'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'profileTransmitterModelNum'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'transmitterSoftwareVersion'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'lastConnectionType'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'lastCommunicationDate'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'lastDeviceCheckDate'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'shippedSerialNum'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'shippedDate'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'shippedModelNum'
        ].disable();
        this.enrollPatientTransmitterFormGroup.controls[
            'orderedDate'
        ].disable();
    }

    cancel() {
        this.globalInputSecurity.dismissXssToasts();
        this.router.navigate(['patient-list']);
    }
    isBackActivated: boolean = false;
    back() {
        this.globalInputSecurity.dismissXssToasts();
        this.isBackActivated = true;
        this.continue();
        // this.navBackward.emit('backward');
    }
    getErrorList(title, errorMsgs) {
        title = title.toString().replace(/<br>/g, '');
        let ulStr: any =
            '<div class="errormsg"><ul class="mt-10">' + "<li>" + title + "</li>";
        errorMsgs.forEach((err) => {
            if (err) {
                const error = this.localizationService.generateLocalizedStr(
                    TRANSMITTER_FIELD[err] ? TRANSMITTER_FIELD[err] :
                    err,
                    { '0': '' },
                    'html'
                );
                ulStr += '<li>' + error + '</li>';
            }
        });
        ulStr += '</ul></div>';
        let x = document.createElement('span');
        x.innerHTML = ulStr;
        return x.innerHTML;
    }

    saveAndClose() {
        if (this.toasterRef) {
            this.toastrService.clear(this.toasterRef.toastId);
        }
        this.clickSaveAndClose = true;
        this.continue();
    }

    onSaveAndCloseWithXssValidation(): void {
        const scope = this.elementRef.nativeElement;
        if (!this.globalInputSecurity.validateScopeForXss(scope)) {
            return;
        }
        this.saveAndClose();
    }

    continue() {
        if (this.toasterRef) {
            this.toastrService.clear(this.toasterRef.toastId);
        }
        const isSnoozeDateEmpty = this.snoozeDateString == '';
        let snoozeUntilDateRaw =
            this.enrollPatientTransmitterFormGroup.get('snoozeUntilDate')?.value;
        if (snoozeUntilDateRaw) {
            let parsedDate = moment(snoozeUntilDateRaw, this.dateFormat.toUpperCase(),true).toDate();
            this.enrollPatientTransmitterFormGroup
                ?.get('snoozeUntilDate')
                ?.setValue(parsedDate);
        } else if (isSnoozeDateEmpty) {
            this.enrollPatientTransmitterFormGroup
                ?.get('snoozeUntilDate')?.setValue('');
        }
        this.snoozeUntilDateDPchanged(this.snoozeDateString);

        this.formErrorHandling();
        if (!this.isError) {
            this.errorMsgs = [];
            this.dataMsgs = [];

            let endPoint: EnrollPatientTransmitter =
                this.enrollPatientTransmitterFormGroup.getRawValue();
            endPoint.netTransmitterInfo = this.netTransmitterInfo;
            endPoint.identifyKeyEpisodeFlg = this.identifyKeyEpisodeFlg;
            const backupSerialModel = {
                transmitterModelNum: endPoint.transmitterModelNum,
                transmitterSerialNum: endPoint.transmitterSerialNum,
            };
            if (!this.serialNumberChange) {
                // delete endPoint.transmitterModelNum;
                // delete endPoint.transmitterSerialNum;
                endPoint.serialNumberModified = false;
                endPoint.modelNumberModified = false;
            } else {
                endPoint.serialNumberModified = true;
                endPoint.modelNumberModified = true;
            }

            if (
                endPoint.modelNumberModified == true &&
                endPoint.serialNumberModified == true &&
                endPoint.profileTransmitterSerialNum == '' &&
                endPoint.profileTransmitterModelNum == ''
            ) {
                endPoint.profileTransmitterSerialNum =
                    this.labels['label.gb.n_a'];
                endPoint.profileTransmitterModelNum =
                    this.labels['label.gb.n_a'];
                endPoint.transmitterSoftwareVersion =
                    this.labels['label.gb.n_a'];
            }

            if (
                endPoint.shippedDate ==
                this.labels['label.gb.n_a']
            ) {
                delete endPoint.shippedDate;
            }
            if (
                endPoint.shippedSerialNum ==
                this.labels['label.gb.n_a']
            ) {
                delete endPoint.shippedSerialNum;
            }
            if (
                endPoint.shippedModelNum ==
                this.labels['label.gb.n_a']
            ) {
                delete endPoint.shippedModelNum;
            }
            if (
                endPoint.orderedDate ==
                this.labels['label.gb.n_a']
            ) {
                delete endPoint.orderedDate;
            }
            endPoint.baMistThresholdSaved = this.baMistThresholdSaved;
            endPoint.batteryAdvisory = this.batteryAdvisory;
            endPoint.bluetoothMistThreshold = this.bluetoothMistThreshold;
            endPoint.bluetoothNodcThreshold = this.bluetoothNodcThreshold;
            endPoint.bluetoothCapable = this.bluetoothCapable;
            endPoint.transmitterModelNum =
                endPoint.transmitterModelNum ==
                    this.labels['label.gb.n_a']
                    ? ''
                    : endPoint.transmitterModelNum;
            const tz = this.dateFormat.toUpperCase();
            endPoint.snoozeUntilDate =
                endPoint.snoozeUntilDate != ''
                    ? moment(endPoint.snoozeUntilDate, tz).format(tz)
                    : '';
            endPoint = {
                ...endPoint,
                mistThreshold:endPoint.mistFlg ? endPoint.mistThreshold : null,
                nodcThreshold:endPoint.nodcFlg? endPoint.nodcThreshold : null,
                oldTransmitterSerialNum: this.oldTransmitterSerialNum,
                oldTransmitterModelNum: this.oldTransmitterModelNum,
            }
            this.dataService
                .updateTransmitterData(this.patientid, endPoint)
                .subscribe(
                    (result: EnrollPatientTransmitter) => {
                        this.enrollPatientTransmitterFormGroup.markAsPristine();
                        if (!this.serialNumberChange) {
                            result = {
                                ...result,
                                transmitterModelNum:
                                    backupSerialModel.transmitterModelNum,
                                transmitterSerialNum:
                                    backupSerialModel.transmitterSerialNum,
                            };
                        }

                        this.viewData = JSON.parse(JSON.stringify(result));
                        this.pareViewDataStrings(this.viewData);
                        this.needConfirmationOnClose = false;

                        if (this.functionMode !== FunctionMode.ENROLL) {
                            let successMsg =
                                this.localizationService.generateLocalizedStr(
                                    'msg.cs830.text'
                                );
                            // this.toastrService.success(successMsg);
                            this.toastrService.show(successMsg, null, {
                                enableHtml: true,
                                toastClass: `${ToasterClass.userNotificationMessageB} ${ToasterClass.ngxToastr}`,
                            });
                        }

                        this.displayMode = 'view';
                        this.mode = Mode.View;
                        this.removeOverrideChecks();
                        this.serialNumberChange = false;
                        if (this.isBackActivated) {
                            this.navBackward.emit('backward');
                            this.isBackActivated = false;
                        } else {
                            if (!this.clickSaveAndClose) {
                                this.goForward.emit('next');
                            } else {
                                //  this.cancel();
                                this.goForward.emit('save-close');
                            }
                        }
                        this.enrollService.updateDeviceFormDirty(false);
                        this.viewTransmitterData();
                        this.setDisplayMode('view');
                    },
                    (error) => {
                        this.clickSaveAndClose = false;
                    if (error?.actionErrors) {
                            if (
                                error.actionErrors[0].message ==
                                'msg.pa883.text'
                            ) {
                                return this.toastrService.show(
                                    this.localizationService.generateLocalizedStr(
                                        'msg.pa883.text',
                                        '',
                                        'html'
                                    ),
                                    null,
                                    {
                                        enableHtml: true,
                                        toastClass: `${ToasterClass.userNotificationMessageA} ${ToasterClass.ngxToastr}`,
                                    }
                                );
                            }
                        }
                        if (error?.actionErrors) {
                            this.showToaster(error.actionErrors);
                            this.enrollPatientTransmitterFormGroup.patchValue({
                                enhancedDiagDataCollection: true,
                            });
                        } else {
                            this.helperService.showErrorToastr(error);
                        }
                        this.enrollService.updateDeviceFormDirty(false);
                        this.spinnerService.visibility = false;
                    }
                );
        }
    }
    dateFormat: string = 'MM-dd-YYYY';
    getUserProfileData() {
        this.userService
                        .getUserProfile(false)
                        .subscribe((userData) => {
                            this.activatorClinicFlg = userData.activatorClinicFlg;
                            this.userProfileCallback(userData);
                            this.tz =  userData.clinicUserTZ;
                            this.userService.setUserObs(userData);
                            localStorage.setItem('dateFormat', userData.dateFormat);
                        });
    }

    getTransmitterModelNumLabel(transmitterModelNum) {
        const transmitterModelNumber =
            this.enrollPatientTransmitter?.dropdowns?.transmitterModelNums.filter(
                (modelNum) => {
                    return modelNum.value == transmitterModelNum;
                }
            );
        return transmitterModelNumber ? transmitterModelNumber[0]?.label : '';
    }

    showTranmissterModel(viewdata: any) {
        if (viewdata.appModelNumber) {
            return this.localizationService.generateLocalizedStr(viewdata.myMerlin, null, 'html') + " " + viewdata.appModelNumber;
        }
    return viewdata.transmitterModelNum ?? this.labels['label.gb.n_a'];
    }

    userProfileCallback(userData) {
        this.dateFormatService.format = userData.dateFormat;
        this.dateFormat = userData.dateFormat;
        this.datePlaceholder = this.localizationService.translatePlaceHolder(this.dateFormat.toUpperCase());
        this.userProfileData = userData;
        this.hasPatientDataEntryAccess = userData?.canEnroll;
        this.isSP2CanEnroll =
            userData.customerType === CustomerType.Direct
                ? true
                : userData?.customerType === CustomerType.ServiceProvider &&
                userData?.canEnroll;

        this.viewTransmitterData();
    }
    serialNumberChange: boolean = false;
    onDropDownChange(event) {
        const transmitterSerialNumControl =
            this.enrollPatientTransmitterFormGroup.get('transmitterSerialNum');
        const transmitterSerialNum = transmitterSerialNumControl.value;
        const control = this.enrollPatientTransmitterFormGroup.get(
            'transmitterModelNum'
        );
        const transmitterModelNum = control.value;
        if (
            !['', null].includes(transmitterModelNum) &&
            this.enrollPatientTransmitterFormGroup.get('transmitterModelNum')
                .value != this.labels['label.gb.n_a']
        ) {
            this.enrollPatientTransmitterFormGroup
                .get('transmitterModelNum')
                .setValidators([Validators.required]);
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .setValidators([
                    Validators.required,
                    Validators.pattern('^[0-9a-zA-z]*$'),
                ]);
            this.enrollPatientTransmitterFormGroup
                .get('transmitterModelNum')
                .updateValueAndValidity();
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .updateValueAndValidity();
            this.transmitterSerialRqdFlag = true;
            if (['', null].includes(transmitterSerialNum)) {
                this.enrollPatientTransmitterFormGroup
                    .get('transmitterSerialNum')
                    .setErrors({ required: true });
            }
        } else if (
            (['', null].includes(transmitterModelNum) ||
                this.enrollPatientTransmitterFormGroup.get(
                    'transmitterModelNum'
                ).value == this.labels['label.gb.n_a']) &&
            ['', null].includes(transmitterSerialNum)
        ) {
            this.enrollPatientTransmitterFormGroup
                .get('transmitterModelNum')
                .clearValidators();
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .clearValidators();
            this.enrollPatientTransmitterFormGroup
                .get('transmitterModelNum')
                .updateValueAndValidity();
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .updateValueAndValidity();
            this.transmitterSerialRqdFlag = false;
        } else if (
            ['', null].includes(transmitterModelNum) ||
            this.enrollPatientTransmitterFormGroup.get('transmitterModelNum')
                .value == this.labels['label.gb.n_a']
        ) {
            this.enrollPatientTransmitterFormGroup
                .get('transmitterModelNum')
                .setErrors({ required: true });
        }
    }

    onTextboxChange(event) {
        const transmitterSerialNumControl =
            this.enrollPatientTransmitterFormGroup.get('transmitterSerialNum');
        const transmitterSerialNum = transmitterSerialNumControl.value;

        if (!['', null].includes(transmitterSerialNum)) {
            this.enrollPatientTransmitterFormGroup
                .get('transmitterModelNum')
                .setValidators([Validators.required]);
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .setValidators([
                    Validators.required,
                    Validators.pattern('^[0-9a-zA-Z]*$'),
                ]);
            this.enrollPatientTransmitterFormGroup
                .get('transmitterModelNum')
                .updateValueAndValidity();
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .updateValueAndValidity();
            if (
                [null, ''].includes(
                    this.enrollPatientTransmitterFormGroup.get(
                        'transmitterModelNum'
                    ).value
                ) ||
                this.enrollPatientTransmitterFormGroup.get(
                    'transmitterModelNum'
                ).value == this.labels['label.gb.n_a']
            ) {
                this.enrollPatientTransmitterFormGroup
                    .get('transmitterModelNum')
                    .setErrors({ incorrect: true });
            }
        } else if (
            ![null, ''].includes(
                this.enrollPatientTransmitterFormGroup.get(
                    'transmitterModelNum'
                ).value
            ) &&
            this.enrollPatientTransmitterFormGroup.get('transmitterModelNum')
                .value != this.labels['label.gb.n_a']
        ) {
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .setValidators([
                    Validators.required,
                    Validators.pattern('^[0-9a-zA-Z]*$'),
                ]);
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .setErrors({ required: true });
            this.transmitterSerialRqdFlag = true;
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .updateValueAndValidity();
        } else {
            this.enrollPatientTransmitterFormGroup
                .get('transmitterModelNum')
                .clearValidators();
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .clearValidators();
            this.enrollPatientTransmitterFormGroup
                .get('transmitterModelNum')
                .updateValueAndValidity();
            this.enrollPatientTransmitterFormGroup
                .get('transmitterSerialNum')
                .updateValueAndValidity();
        }
        this.serialNumberChange = true;
    }

    formErrorHandling() {
        this.isError = false;
        this.errorHeading = null;
        this.errorMsgs = [];
        this.enrollPatientTransmitterFormGroup.markAsDirty();
        if (this.enrollPatientTransmitterFormGroup.invalid) {
            for (let item in this.enrollPatientTransmitterFormGroup.controls) {
                this.errorHandling(
                    this.enrollPatientTransmitterFormGroup.controls[item],
                    item
                );
            }
            this.showErrorMsg();
            return;
        }
    }

    errorHandling(controlItem, name) {

        if (controlItem?.errors?.pattern) {
            this.isError = true;
            this.errorHeading = this.localizationService.generateLocalizedStr(
            FrontEndErrMsgs.invalidField,
            { '0': '' },
            'html'
            );
            this.errorMsgs.push(name);
            if(name === 'snoozeUntilDate'){
                let msgAppendix = this.localizationService.generateLocalizedStr(
                    'msg.cs816.text_appendix',
                    { '0': this.datePlaceholder },
                    'html'
                );
                this.errorMsgs.push(msgAppendix);
            }
        } else if (isControlRequired(controlItem)) {
            this.isError = true;
            this.errorHeading = this.localizationService.generateLocalizedStr(
                FrontEndErrMsgs.reqHeading,
                { '0': '' },
                'html'
            );
            if (name === 'transmitterSerialNum') {
                this.enrollPatientTransmitterFormGroup.controls[
                    'transmitterSerialNum'
                ].markAsTouched();
            }
            this.errorMsgs.push(name);
        } else if (controlItem?.errors) {
            this.isError = true;
            this.errorHeading = this.localizationService.generateLocalizedStr(
                FrontEndErrMsgs.requiredField,
                { '0': '' },
                'html'
            );
            this.errorMsgs.push(name);
        }
    }

    removeOverrides() {
        this.lockOutDeviceCheckboxFlag = false;
        this.lockOutTransCheckboxFlag = false;
        this.enhancedDiagDataCollectionFlag = false;
        this.rfDailyCheckEnabledFlag = false;
        this.identifyKeyEpisodeFlg = null;
        if (
            this.enrollPatientTransmitterFormGroup.get('lockoutTransEnabled')
                .status != 'DISABLED'
        ) {
            this.enrollPatientTransmitterFormGroup
                .get('lockoutTransEnabled')
                .setValue(this.customerJson.lockoutPatientInitTransFlg);
        }

        if (
            this.enrollPatientTransmitterFormGroup.get(
                'lockOutDeviceCheckEnabled'
            ).status != 'DISABLED'
        ) {
            this.enrollPatientTransmitterFormGroup
                .get('lockOutDeviceCheckEnabled')
                .setValue(this.customerJson.lockoutPatientInitDcFlg);
        }

        if (
            this.enrollPatientTransmitterFormGroup.get(
                'enhancedDiagDataCollection'
            ).status != 'DISABLED'
        ) {
            this.enrollPatientTransmitterFormGroup
                .get('enhancedDiagDataCollection')
                .setValue(this.customerJson.enableMedFlg);
        }

        if (
            this.enrollPatientTransmitterFormGroup.get('mistFlg')
                .status != 'DISABLED' &&
            !this.enrollPatientTransmitterFormGroup.get('mistFlg')
                .disabled
        ) {
            this.enrollPatientTransmitterFormGroup.get('mistFlg').setValue(this.customerJson.clinicMistFlg);

            if (this.enrollPatientTransmitterFormGroup.get('mistFlg')?.value) {
                this.mistFlagSelection = true;
                this.enrollPatientTransmitterFormGroup.get('mistThreshold').patchValue(this.customerJson.clinicMistThreshold);
            } else {
                this.mistFlagSelection = false;
                this.enrollPatientTransmitterFormGroup.get('mistThreshold').patchValue(null);
                // When mistFlg is unchecked, disable nodcFlg and clear its threshold
                this.enrollPatientTransmitterFormGroup.get('nodcFlg').patchValue(false);
                this.enrollPatientTransmitterFormGroup.get('nodcFlg').disable();
                this.nodcFlagSelection = false;
                this.enrollPatientTransmitterFormGroup.get('nodcThreshold').patchValue(null);
            }

        }
        let chk = this.enrollPatientTransmitterFormGroup.get(
            'rfDailyCheckEnabled'
        ).disabled;
        if (
            this.enrollPatientTransmitterFormGroup.get('rfDailyCheckEnabled')
                .status != 'DISABLED' &&
            !this.enrollPatientTransmitterFormGroup.get('rfDailyCheckEnabled')
                .disabled
        ) {
            this.enrollPatientTransmitterFormGroup
                .get('rfDailyCheckEnabled')
                .setValue(this.customerJson.deviceCheckFlg);

            if (this.enrollPatientTransmitterFormGroup.get('rfDailyCheckEnabled')?.value) {
                this.directAlertSelection = true;

                if (this.enrollPatientTransmitterFormGroup.get('mistFlg')?.value) {
                    this.enrollPatientTransmitterFormGroup.get('nodcFlg').enable();
                    this.enrollPatientTransmitterFormGroup.get('nodcFlg').patchValue(this.customerJson.clinicNodcFlg);

                    if (this.enrollPatientTransmitterFormGroup.get('nodcFlg')?.value) {
                        this.nodcFlagSelection = true;
                        this.enrollPatientTransmitterFormGroup.get('nodcThreshold').patchValue(this.customerJson.clinicNodcThreshold);
                    } else {
                        this.nodcFlagSelection = false;
                    }
                } else {
                    this.enrollPatientTransmitterFormGroup.get('nodcFlg').patchValue(false);
                    this.enrollPatientTransmitterFormGroup.get('nodcFlg').disable();
                    this.nodcFlagSelection = false;
                }

            } else {
                this.directAlertSelection = false;
                this.enrollPatientTransmitterFormGroup.get('nodcFlg').patchValue(false);
                this.enrollPatientTransmitterFormGroup.get('nodcFlg').disable();
                this.nodcFlagSelection = false;
            }
        }

        if (
            this.enrollPatientTransmitterFormGroup.get('effectiveKeyEpisodeFlg')
                .status != 'DISABLED' &&
            !this.enrollPatientTransmitterFormGroup.get('effectiveKeyEpisodeFlg')
                .disabled
       ) {
            this.enrollPatientTransmitterFormGroup
                ?.get('identifyKeyEpisodeFlg')
                .setValue(null);
                this.identifyKeyEpisodeFlg=null;

            this.enrollPatientTransmitterFormGroup
                ?.get('effectiveKeyEpisodeFlg')
                .setValue(this.customerJson['clinicKeyEpisodeFlg']);
                this.effectiveKeyEpisodeFlg = this.customerJson['clinicKeyEpisodeFlg'];
        }

        this.enrollPatientTransmitterFormGroup.markAsDirty();
        this.enrollPatientTransmitterFormGroup.markAllAsTouched();
        this.updateSettingDisabledStates();
    }

    profileMode() {
        if (this.functionMode == 'profile') {
            return true;
        } else {
            return false;
        }
    }

    viewMode() {
        if (this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }
    viewAndEnrollMode() {
        if (this.displayMode == 'edit' || this.functionMode == 'enroll') {
            return false;
        } else {
            return true;
        }
    }

    editMode() {
        if (this.displayMode == 'edit') {
            return true;
        } else {
            return false;
        }
    }
    showOverrideBtn() {
        if (!this.customerJson) return false;

        const fg = this.enrollPatientTransmitterFormGroup;
        const isEnroll = this.functionMode === 'enroll';
        const isEdit = this.displayMode === 'edit';

        // Helper for override check
        const isOverride = (
            (!this.lpDeviceType && fg.get('rfDailyCheckEnabled')?.value !== this.customerJson['deviceCheckFlg']) ||
            (!this.icmDeviceType && (
                fg.get('lockoutTransEnabled')?.value !== this.customerJson['lockoutPatientInitTransFlg'] ||
                (this.unityDeviceType && fg.get('lockOutDeviceCheckEnabled')?.value !== this.customerJson['lockoutPatientInitDcFlg'])
            )) ||
            (this.showIdentifyKeyEpisodesSetting && fg.get('effectiveKeyEpisodeFlg')?.value !== this.customerJson['clinicKeyEpisodeFlg']) ||
            (this.unityDeviceType && (!this.enhancedDiagDataCollectionNewflag && fg.get('enhancedDiagDataCollection')?.value !== this.customerJson['enableMedFlg']))
        );

        return (isEnroll || isEdit) ? isOverride : false;
    }

    setDisplayMode(value: string) {
        this.displayMode = value;
        this.mode = value == 'view' ? Mode.View : Mode.Edit;
        this.nodcFlagSelection =
            this.enrollPatientTransmitterFormGroup.get('nodcFlg').value;
        let serialNum = this.enrollPatientTransmitterFormGroup
            .get('transmitterSerialNum')
            .value.replace(/^0+/, '');
        this.enrollPatientTransmitterFormGroup
            .get('transmitterSerialNum')
            .setValue(serialNum);
        this.updateSettingDisabledStates();
    }

    /**
     * Reapply legacy default checked behavior that relied on multiple flags.
     * This runs after incoming data patch to ensure form reflects intended defaults.
     */
    private applyDefaultCheckboxStates(): void {
        const fg = this.enrollPatientTransmitterFormGroup;
        if (!fg || !this.enrollPatientTransmitter) return;
        const data = this.enrollPatientTransmitter;

        // rfDailyCheckEnabled:
        if (!this.lpDeviceType) {
            const viewFlag = this.isViewMode() && data.rfDailyCheckEnabled;
            const isNonBtRFDailyChecked = !this.bluetoothCapable &&
            ((data?.followUpCapable &&( data?.rfDailyCheckEnabled && data?.deviceRfStatusFlag)) ||
            (!data?.followUpCapable && data?.rfDailyCheckEnabled));
            const isBtRFDailyChecked = this.bluetoothCapable && data?.rfDailyCheckEnabled;
            fg.get('rfDailyCheckEnabled')?.setValue(
                viewFlag || (!this.isViewMode() && (isNonBtRFDailyChecked || isBtRFDailyChecked)),
                { emitEvent: false }
            );
        }

        //lockoutTransEnabled
        const isBtLockoutTransChecked = this.bluetoothCapable && data?.lockoutTransEnabled;
        const isLpDefault = this.lpDeviceType && !!this.customerJson?.lockoutPatientInitTransFlg;
        const isNonBtLockoutTransChecked = !this.bluetoothCapable && (isLpDefault ||
        (data.followUpCapable && (data.deviceFamily !== 1) && data?.lockoutTransEnabled) ||
        (!data.followUpCapable && (data?.lockoutTransEnabled || (!data?.lockoutTransEnabled && (this.mode !== 'view') && data.deviceSwitchOverrideFlag))));
        fg.get('lockoutTransEnabled')?.setValue(isBtLockoutTransChecked || isNonBtLockoutTransChecked, { emitEvent: false });

        // lockOutDeviceCheckEnabled
        const isNonBtDcChecked = !this.bluetoothCapable && ((data.followUpCapable && (data.deviceFamily !== 1) && data?.lockOutDeviceCheckEnabled) ||
        (!data.followUpCapable && data?.lockOutDeviceCheckEnabled));
        fg.get('lockOutDeviceCheckEnabled')?.setValue(isNonBtDcChecked, { emitEvent: false });

        // enhancedDiagDataCollection
        if (!this.enhancedDiagDataCollectionNewflag) {
            if (!this.bluetoothCapable) {
                fg.get('enhancedDiagDataCollection')?.setValue(data.enhancedDiagDataCollection, { emitEvent: false });
            }
        }

        // effectiveKeyEpisodeFlg: if setting shown and server provided value null, default to clinic flag.
        if (this.showIdentifyKeyEpisodesSetting) {
            const effCtrl = fg.get('effectiveKeyEpisodeFlg');
            if (effCtrl && (effCtrl.value === null || effCtrl.value === undefined)) {
                effCtrl.setValue(this.customerJson?.clinicKeyEpisodeFlg ?? false, { emitEvent: false });
            }
        }

        // Mist / NODC: ensure thresholds nullified when flags are false.
        if (!fg.get('mistFlg')?.value) {
            fg.get('mistThreshold')?.setValue(null, { emitEvent: false });
        }
        if (!fg.get('nodcFlg')?.value) {
            fg.get('nodcThreshold')?.setValue(null, { emitEvent: false });
        }
    }

    // ---------------- Mist / NODC Threshold Helpers ----------------
    showMistThresholdSelector(): boolean {
        return !!(this.showTextBox() && !this.devMedFlag && this.mistFlagSelection);
    }
    getMistThresholdDisplay(): string {
        const v = this.viewData;
        if (!v?.mistFlg) return '';
        const threshold = v?.mistThreshold;
        if (!threshold || threshold === 0) return '';
        return `${threshold} ${this.translate('label.gb.days')}`;
    }
    getMistScheduleDailyDisplay(): string {
        if (!this.devMedFlag) return '';
        const v = this.viewData;
        if (!v?.mistFlg) return '';
        if (v?.mistThreshold && v.mistThreshold !== 0) {
            return `${this.defaultMistThresholdForScheduleDaily ?? v.mistThreshold} ${this.translate('label.gb.days')}`;
        }
        return '';
    }
    showNodcThresholdSelector(): boolean {
        return !!(this.showTextBox() && this.nodcFlagSelection && this.mistFlagSelection && this.directAlertSelection);
    }
    getNodcThresholdDisplay(): string {
        const v = this.viewData;
        if (!v?.nodcFlg) return '';
        const t = v?.nodcThreshold;
        if (!t || t === 0) return '';
        return `${t} ${this.translate('label.gb.days')}`;
    }
    // ---------------------------------------------------------------

    onSaveButtonClick() {
        this.displayMode = 'edit';
    }

    showVolume(transmitterCodeId) {
        const selectedVolume =
            this.enrollPatientTransmitter?.dropdowns.volumeCd.filter(
                (currObj: VolumeCode) => {
                    return currObj.codeId == transmitterCodeId;
                }
            )[0];
        return selectedVolume
            ? this.translate(
                'data.Code.Transmitter_Volume_Cd.Code_Desc.' +
                selectedVolume?.code
            )
            : '';
    }

    cancelEditClick() {
        this.viewTransmitterData();
        this.getUserProfileData();
        this.toastrService.clear();
        if (this.functionMode == 'enroll') {
            this.mode = Mode.View;
        }
        this.setDisplayMode('view');
        this.enrollPatientTransmitterFormGroup.markAsPristine();
    }

    showTextBox() {
        if (this.bluetoothCapable) {
            this.enrollPatientTransmitterFormGroup.controls[
                'transmitterModelNum'
            ].disable();
        }
        if (this.functionMode == 'enroll') {
            return true;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return true;
        } else {
            return false;
        }
    }

    showTextLabel() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    transmitterCommunicationDisable() {
        if (this.deviceInductive == true) {
            return true;
        } else if (this.displayMode == 'view') {
            this.viewEnhancedDiagDataFlag = true;
        }

        if (this.functionMode == 'enroll') {
            return false;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return false;
        } else {
            return true;
        }
    }

    directAlertsChecboxDisable() {
        if (
            this.directAlertSelection === false ||
            this.mistFlagSelection === false
        ) {
            return true;
        }
        if (this.functionMode == 'enroll') {
            return false;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return false;
        } else {
            return true;
        }
    }

    profileSaveClick() {
        if ((this.enrollPatientTransmitterFormGroup.touched && this.enrollPatientTransmitterFormGroup.dirty)
            || this.enrollPatientTransmitterFormGroup.invalid) {
            this.toasterRef
                ? this.toastrService.clear(this.toasterRef.toastId)
                : '';

            if (
                this.functionMode === 'profile' &&
                this.displayMode === 'edit' &&
                !this.enrollPatientTransmitterFormGroup.dirty
            ) {
                this.displayMode = 'view';
                return;
            }

            if (
                this.enrollPatientTransmitter?.transmitterSerialNum &&
                !this.enrollPatientTransmitterFormGroup.get('transmitterSerialNum')
                    .value &&
                !this.enrollPatientTransmitterFormGroup.get('transmitterModelNum')
                    .value
            ) {
                const dialogConfig: PopupConfig = this.generatePopUpconfig(
                    this.translate('msg.pa887.text'),
                    PopupType.Confirm
                );
                this.popupService.open(dialogConfig);
                this.popupService.dialogRef
                    .afterClosed()
                    .subscribe((response: any) => {
                        if (response) {
                            this.continue();
                        } else {
                            return;
                        }
                    });
            } else {
                this.continue();
            }
        } else {
            this.cancelEditClick()
        }
    }

    openShowDevicesDialog() {
        const dialogRef = this.dialog.open(IcmaiDevicesDialogComponent, {
            data: { patientId: this.patRes?.patient?.patientId, isClinicLevel: false },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((result) => {});
    }

    openPrintDialog() {
        const dialogRef = this.dialog.open(PatientProfilePrintDialogComponent, {
            data: {
                patientid: this.patientid,
                patRes: this.patRes,
            },
        });
        dialogRef.afterClosed().subscribe((result) => { });
    }
    getLastConnectionTypeDate(viewData) {
        return !["", null].includes(viewData.lastConnectionType)
            ? viewData.lastConnectionType == 'label.gb.n_a' ? this.labels['label.gb.n_a']
                : this.translate('data.Code.Communication_Type_Cd.Code_Desc.' + viewData.lastConnectionType)
            : '';
    }
    getLastCommunicationDate(viewData) {
        return viewData.lastCommunicationDate != null
            ? viewData.lastCommunicationDate === 'label.gb.n_a'
                ? this.labels['label.gb.n_a']
                : viewData.lastCommunicationDate
            : this.labels['label.gb.n_a'];
    }
    getLasDeviceCheckDate(viewData) {
        return viewData.lastDeviceCheckDate != null
            ? viewData.lastDeviceCheckDate === 'label.gb.n_a'
                ? this.labels['label.gb.n_a']
                : viewData.lastDeviceCheckDate
            : this.labels['label.gb.n_a'];
    }
    translate(key: string): any {
        return this.localizationService.generateLocalizedStr(key, null, 'html');
    }
    translateKey(key: string, value): any {
        const params: any = { 0: value };
        return this.localizationService.generateLocalizedStr(key, params);
    }
    bindFieldsData(records) {
        this.route.params.subscribe((res) => {
            if (res?.id) {
                this.enrollPatientTransmitterFormGroup
                    .get('transmitterSerialNum')
                    .patchValue(records.transmitterSerialNum);
                this.enrollPatientTransmitterFormGroup
                    .get('profileTransmitterSerialNum')
                    .patchValue(records.profileTransmitterSerialNum);
                this.enrollPatientTransmitterFormGroup
                    .get('shippedSerialNum')
                    .patchValue(records.shippedSerialNum);
                let transmissionNumber = this.localizationService.generateLocalizedStr(records.myMerlin, null, 'html') + records.transmitterModelNum;

                this.enrollPatientTransmitterFormGroup
                    .get('transmitterModelNum')
                    .patchValue(transmissionNumber);
                this.enrollPatientTransmitterFormGroup
                    .get('profileTransmitterModelNum')
                    .patchValue(records.profileTransmitterModelNum);
                this.enrollPatientTransmitterFormGroup
                    .get('shippedModelNum')
                    .patchValue(records.shippedModelNum);
                this.enrollPatientTransmitterFormGroup
                    .get('transmitterSoftwareVersion')
                    .patchValue(records.transmitterSoftwareVersion);
                this.enrollPatientTransmitterFormGroup
                    .get('registrationDate')
                    .patchValue(records.registrationDate);

                let lastConnectionType = ![null, ""].includes(records.lastConnectionType) ? records.lastConnectionType == 'label.gb.n_a' ? this.labels['label.gb.n_a'] :
                this.localizationService.generateLocalizedStr('data.Code.Communication_Type_Cd.Code_Desc.' + records.lastConnectionType, null, 'html',) : '';
                this.enrollPatientTransmitterFormGroup
                    .get('lastConnectionType')
                    .patchValue(lastConnectionType);

                this.enrollPatientTransmitterFormGroup
                    .get('lastCommunicationDate')
                    .patchValue(records.lastCommunicationDate);
                this.enrollPatientTransmitterFormGroup
                    .get('lastDeviceCheckDate')
                    .patchValue(records.lastDeviceCheckDate);
                this.enrollPatientTransmitterFormGroup
                    .get('transmitterVolumeCd')
                    .patchValue(records.transmitterVolumeCd);
                this.enrollPatientTransmitterFormGroup
                    .get('orderedDate')
                    .patchValue(records?.orderedDate);
                this.enrollPatientTransmitterFormGroup
                    .get('shippedDate')
                    .patchValue(records.shippedDate);
                this.enrollPatientTransmitterFormGroup
                    .get('rfDailyCheckEnabled')
                    .patchValue(records.rfDailyCheckEnabled);
                this.enrollPatientTransmitterFormGroup
                    .get('identifyKeyEpisodeFlg')
                    .patchValue(records.identifyKeyEpisodeFlg);
                this.enrollPatientTransmitterFormGroup
                    .get('effectiveKeyEpisodeFlg')
                    .patchValue(records.identifyKeyEpisodeFlg);
                this.enrollPatientTransmitterFormGroup
                    .get('lockoutTransEnabled')
                    .patchValue(records.lockoutTransEnabled);
                this.enrollPatientTransmitterFormGroup
                    .get('lockOutDeviceCheckEnabled')
                    .patchValue(records.lockOutDeviceCheckEnabled);
            }
        });
    }
    showToaster(actionErrors: ActionError[]) {
        this.errorMsgs = [];
        actionErrors.forEach((item) => {
            const allKeys = Object.keys(item.parameters ?? {});
            let message = this.localizationService.generateLocalizedStr(
                item.message
            );
            allKeys.forEach((key) => {
                const param = item.parameters[key].message;
                message = message.replace(`{${key}}`, param);
            });

            this.errorMsgs.push(message);
            const errorMsg = this.helperService.getErrorList(this.errorMsgs);
            if (actionErrors.length == this.errorMsgs.length) {
                if (actionErrors[0].message === 'msg.pa870.text') {
                    this.toastrService.success(errorMsg, null, {
                        enableHtml: true,
                        disableTimeOut: false,
                    });
                } else {
                    this.toasterRef = this.toastrService.error(errorMsg, null, {
                        enableHtml: true,
                        disableTimeOut: true,
                        tapToDismiss: false,
                    });
                }
            }
        });
    }
    showErrorMsg() {
        const listError = this.getErrorList(this.errorHeading, this.errorMsgs);
        this.toasterRef = this.toastrService.error(listError, null, {
            enableHtml: true,
            disableTimeOut: true,
            tapToDismiss: false,
        });
        window.scrollTo(0, 0);
        return false;
    }
    snoozeUntilDateDPchanged(evt) {
        this.snoozeDateString = isMoment(evt) ? evt.format(this.dateFormat.toUpperCase()) : evt;
        const isValidDate = this.helperService.dateValidator(this.snoozeDateString, this.dateFormat);
        let emptyDate = this.snoozeDateString === ''
        let isPastDate = false;
        if(isValidDate) {
            isPastDate = moment(this.snoozeDateString, this.dateFormat.toUpperCase()).isSameOrBefore(moment(), 'day');
        }
        this.enrollPatientTransmitterFormGroup.get('snoozeUntilDate')?.setErrors(emptyDate || (isValidDate && !isPastDate) ? null : { pattern: true });
        this.enrollPatientTransmitterFormGroup.get('snoozeUntilDate')?.markAsTouched();
    }

    reActivatePatient() {
        if (this.hasPatientDataEntryAccess) {
            this.patientListService
                .updateReactivatePatient([this.patientid])
                .subscribe(
                    (res) => {
                        this.toastrService.success(
                            this.localizationService.generateLocalizedStr(
                                'msg.pa800b.text',
                                { 0: '1' }
                            )
                        );
                        this.isPatientRelease = false;
                    },
                    (err) => {
                        this.helperService.showErrorToastr(err);
                    }
                );
        }
    }
    releasePatient() {
        const patientIds = [+this.patientid];

        this.patientListService.getReleasePatientData(patientIds).subscribe(
            (res) => {
                const releasePatientDRef = this.dialog.open(
                    ReleasePatientDialogComponent,
                    {
                        width: '900px',
                        // height:'600px',
                        data: {
                            patients: res.releasePatientSummaryDTO.map((a) => {
                                a.patientInfo['isTransmissionComplete'] =
                                    a.isTransmissionComplete;
                                return a.patientInfo;
                            }),
                            clinicFavoriteDTO: res.clinicFavoriteDTO,
                            releaseReasonCd: res.releaseReasonCd,
                            transferCustApplId: res.transferCustApplId,
                        },
                    }
                );

                releasePatientDRef.afterClosed().subscribe((result) => {
                    if (result.reasonForReasonFlag) {
                        const selectedIds = [this.patientid];
                        let data = {
                            patientIds: selectedIds,
                            releaseReasonCode: result.reasonForReasonFlag,
                            transferCustApplId: result.transferCustApplId
                                ? result.transferCustApplId
                                : '',
                        };
                        this.patientListService
                            .updateReleasePatient(data)
                            .subscribe((response) => {
                                const refTransferCusDetails =
                                    res.clinicFavoriteDTO &&
                                    res.clinicFavoriteDTO.find(
                                        (a) =>
                                            a.associatedCustApplId ===
                                            result.transferCustApplId
                                    );
                                let releasePatient =
                                    this.translateService.instant(
                                        'msg.pa834b.text'
                                    );

                                if (refTransferCusDetails) {
                                    releasePatient += ` ${refTransferCusDetails.name} : ${refTransferCusDetails.phoneNum} `;
                                }
                                if (result.reasonForReasonFlag === 'R' &&
                                    result.selectedClinicDetails) {
                                    const phone = `${result.selectedClinicDetails.countryCode}-${result.selectedClinicDetails.areaCode}-${result.selectedClinicDetails.phoneNum}`;
                                    const releaseTxt =  this.activatorClinicFlg ? 'msg.patrel_actclinic.text' : 'msg.patrel_regclinic.text';
                                        releasePatient = result.selectedClinicDetails.customerId !=null
                                         ?
                                         this.translateMsg( releaseTxt,
                                            {
                                                0: result.selectedClinicDetails.name,
                                                1: phone,
                                            }, ReturnType.HTML
                                        ) : this.translateMsg('msg.pa834a.text', null, ReturnType.HTML);

                                        this.isPatientRelease = true;
                                        this.releasePatientMsg = releasePatient;
                                } else{
                                    this.isPatientRelease = false;
                                    this.releasePatientMsg = '';
                                }

                                if (this.profileMode()) {
                                    this.toastrService.success(
                                        this.localizationService.generateLocalizedStr(
                                            'msg.pa834b.text'
                                        )
                                    );
                                    this.getUserProfileData();
                                }
                            });
                    }
                });
            },
            (err) => {
                this.helperService.showErrorToastr(err);
            }
        );
    }

    translateMsg(key, params, returnType) {
        return this.localizationService.generateLocalizedStr(
            key,
            params,
            returnType
        );
    }
    generatePopUpconfig(msgKey: string, popupType) {
        return {
            type: popupType,
            message: this.localizationService.generateLocalizedStr(
                msgKey,
                null,
                'html'
            ),
            confirmText:
                this.localizationService.generateLocalizedStr('label.gb.ok'),
            confirmId: this.identifierService.buttonId(
                'pcs-location-popup',
                'ok'
            ),
            cancelId: this.identifierService.buttonId(
                'pcs-location-popup',
                'cancel001'
            ),
            cancelText:
                popupType == PopupType.Confirm
                    ? this.localizationService.generateLocalizedStr(
                        'label.gb.button_cancel'
                    )
                    : '',
            customPopup: true,
        };
    }
    getPatientData() {
        this.enrollService
            .getDeviceData(this.functionMode, this.patientid)
            .subscribe(
                (res) => {
                    this.patRes = res;
                    const deviceName = this.getDeviceName();
                    if (deviceName.includes(4500)) {
                        this.deviceModelNumber = 4500;
                    } else if (deviceName.includes(3500)) {
                        this.deviceModelNumber = 3500;
                    }
                },
                (err) => {
                    this.helperService.showErrorToastr(err);
                }
            );
    }
    getDeviceName() {
        let patDevice = this.patRes.dropdowns
            ? this.patRes.dropdowns.devices.filter((dev) => {
                return dev.value == this.patRes.patientDevices?.[0]?.productId;
            })
            : [];
        return patDevice.length !== 0 ? patDevice[0]?.label : '';
    }
    getProfileTransmitterSerialNum(viewData) {
        return viewData.profileTransmitterSerialNum != null
            ? viewData.profileTransmitterSerialNum === 'label.gb.n_a'
                ? this.labels['label.gb.n_a']
                : viewData.profileTransmitterSerialNum.replace(/^0+/, '')
            : this.labels['label.gb.n_a'];
    }

    getProfileSerial(transmitterSerialNum) {
        return transmitterSerialNum != null
            ? transmitterSerialNum === 'label.gb.n_a'
                ? this.labels['label.gb.n_a']
                : transmitterSerialNum.replace(/^0+/, '')
            : this.labels['label.gb.n_a'];
    }

    getProfileTransmitterModelNum(viewData) {
        return viewData.profileTransmitterModelNum != null
            ? viewData.profileTransmitterModelNum === 'label.gb.n_a'
                ? this.labels['label.gb.n_a']
                : viewData.profileTransmitterModelNum
            : this.labels['label.gb.n_a'];
    }
    getTransmitterSoftwareVersion(viewData) {
        return viewData.transmitterSoftwareVersion != null
            ? viewData.transmitterSoftwareVersion === 'label.gb.n_a'
                ? this.labels['label.gb.n_a']
                : viewData.transmitterSoftwareVersion
            : this.labels['label.gb.n_a'];
    }
}

export const isControlRequired = (control: AbstractControl): boolean => {
    if (!control) {
        return false;
    }

    if (control.validator) {
        const validator = control.validator({} as AbstractControl);
        if (validator && validator.required) {
            if (!control.value || control.value === '') {
                return true;
            } else {
                return false;
            }
        }
    }
    if (control?.errors) {
        return true;
    }

    return false;
};
